import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal, Overline, EASE } from "@/lib/Reveal";
import { FAQS } from "@/lib/site";

export default function FaqSection() {
    const [open, setOpen] = useState(0);

    return (
        <section id="faqs" data-testid="faq-section" className="py-20 lg:py-28 bg-[#FAFAFA]">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-4">
                        <div className="lg:sticky lg:top-28">
                            <Reveal>
                                <Overline>FAQs</Overline>
                                <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-neutral-900 mt-4 leading-[1.05]">
                                    Questions,
                                    <br />
                                    answered
                                </h2>
                                <p className="mt-5 text-base text-neutral-600 leading-relaxed">
                                    Everything you need to know before getting in touch. Still unsure? Call us on{" "}
                                    <a href="tel:+447718580408" className="font-bold text-[#E85A1D]">
                                        07718 580408
                                    </a>
                                    .
                                </p>
                            </Reveal>
                        </div>
                    </div>

                    <div className="lg:col-span-8">
                        {FAQS.map((f, i) => {
                            const isOpen = open === i;
                            return (
                                <Reveal key={f.q} delay={i * 0.04}>
                                    <div
                                        data-testid="faq-accordion-item"
                                        className={`border-b border-[#E5E5E0] first:border-t transition-colors duration-300 ${isOpen ? "bg-[#FFF1EB]/50" : ""} rounded-lg`}
                                    >
                                        <button
                                            onClick={() => setOpen(isOpen ? -1 : i)}
                                            aria-expanded={isOpen}
                                            className="w-full flex items-center justify-between gap-6 text-left px-4 sm:px-6 py-6"
                                        >
                                            <span className="font-display text-lg sm:text-xl font-bold tracking-tight text-neutral-900">
                                                {f.q}
                                            </span>
                                            <motion.span
                                                animate={{ rotate: isOpen ? 45 : 0 }}
                                                transition={{ duration: 0.3, ease: EASE }}
                                                className={`w-9 h-9 shrink-0 rounded-full flex items-center justify-center transition-colors duration-300 ${
                                                    isOpen ? "bg-[#E85A1D] text-white" : "bg-[#F3F3EF] text-neutral-700"
                                                }`}
                                            >
                                                <Plus className="w-5 h-5" />
                                            </motion.span>
                                        </button>
                                        <AnimatePresence initial={false}>
                                            {isOpen && (
                                                <motion.div
                                                    initial={{ height: 0, opacity: 0 }}
                                                    animate={{ height: "auto", opacity: 1 }}
                                                    exit={{ height: 0, opacity: 0 }}
                                                    transition={{ duration: 0.4, ease: EASE }}
                                                    className="overflow-hidden"
                                                >
                                                    <p className="px-4 sm:px-6 pb-7 text-sm sm:text-base text-neutral-600 leading-relaxed max-w-2xl">
                                                        {f.a}
                                                    </p>
                                                </motion.div>
                                            )}
                                        </AnimatePresence>
                                    </div>
                                </Reveal>
                            );
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
}
